import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './ui';
import authReducer from './auth';
import settingsReducer from './user-settings';
import appSettingsReducer from './settings';
import talentReducer from './talent';
import shiftReducer from './shifts';
import companyReducer from './company';
import skillReducer from './skills';

export default combineReducers({
    ui: uiReducer,
    auth: authReducer,
    settings: settingsReducer,
    appSettings: appSettingsReducer,
    talent: talentReducer,
    shifts: shiftReducer,
    companies: companyReducer,
    skills: skillReducer,
});
